import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import _ from "underscore";

import $ from "#jquery/jquery.ts";
import LayeredComponentMixin from "#react-components-package/layered-component-mixin.tsx";
// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import DeprecatedModal from "#shared-components-package/deprecated-modal.tsx";

import AvatarCustomizer from "./avatar-customizer.tsx";

const RP = PropTypes;

const AvatarCustomizerModal: any = createReactClass({
    displayName: "AvatarCustomizerModal",

    propTypes: {
        /** The name of the avatar part that should be shown on open. */
        initialSelectionName: RP.string,

        /** Called to indicate the modal should be closed. */
        onClose: RP.func.isRequired,

        /** Once part of ProfileModel, but separated out for efficiency. */
        hasChangedAvatar: RP.bool,
    },

    mixins: [LayeredComponentMixin],

    getInitialState: function (this: any) {
        return {
            componentMounted: false,
        };
    },

    componentDidMount: function (this: any) {
        this._isMounted = true;

        // Completely disable page scrolling when avatar customizer modal is
        // shown. We do this mostly because we have scrollable elements
        // (overflow: auto) within the modal, and we don't want scrolling
        // within those elements to continue scrolling the page (which happens
        // when you're scrolling with a mousewheel or trackpad). There are
        // solutions that only disable page scrolling when you're scrolling
        // within specified elements (I've found
        // http://stackoverflow.com/a/16324762/392426 to work the best), but
        // these are hacky and in general, we think it makes sense to disable
        // page scrolling completely. Scrolling is only enabled when the
        // user's window size is too small to interact with the save and
        // cancel buttons at the bottom of the modal.
        if ($(window).height() > 680) {
            $("html, body").addClass("disable-vertical-scrolling");
        }

        // We set state to force another render because adding the
        // 'disable-vertical-scrolling' class will affect DOM position
        // computations in renderLayer.
        this.setState({componentMounted: true});
    },

    componentWillUnmount: function (this: any) {
        $("html, body").removeClass("disable-vertical-scrolling");

        this._isMounted = false;
    },

    // TODO(briangenisio): This is a hack to remove the deprecated call to
    // this.isMounted() but is still considered an anti-pattern.  Replace
    // with code which does not rely on the mounted state like Redux or GraphQL
    _isMounted: false,

    handleModalClose: function (this: any) {
        // We close the modal in the next tick because if this.props.onClose()
        // unmounts this component, then this function will be invoked (from
        // the modal's close event), and we don't want to double-unmount.
        // Instead, we wait a tick and see if we are still mounted before
        // calling this.props.onClose().
        _.delay(() => {
            if (this._isMounted) {
                this.props.onClose();
            }
        });
    },

    renderLayer: function (this: any) {
        if (!this.state.componentMounted) {
            return <div />;
        }

        return (
            <DeprecatedModal
                className="avatar-customizer"
                extraWide={true}
                onClose={this.handleModalClose}
            >
                <AvatarCustomizer
                    initialSelectionName={this.props.initialSelectionName}
                    onClose={this.props.onClose}
                    hasChangedAvatar={this.props.hasChangedAvatar}
                />
            </DeprecatedModal>
        );
    },

    render: function (this: any) {
        // We only care about rendering the modal in renderLayer
        return <div />;
    },
});

export default AvatarCustomizerModal;
